// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutPaymentListFooter_container__2La-P","change":"CheckoutPaymentListFooter_change__2ZAsI","change-ltr":"CheckoutPaymentListFooter_change-ltr__3EhKd"};